exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody {\n    background: #000000;\n}\n#___gatsby {\n    background: #ffffff;\n}\n\nbody,\nbutton,\ninput,\nbutton {\n    font-family: Greycliff, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nimage {\n    -webkit-user-drag: none;\n    user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -webkit-user-select: none;\n}\n", ""]);

// exports
